import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  SummaryMain,
  SummaryItemMain,
  SummaryItemLabel,
  SummaryItemCount,
  TrackerTitle
} from './css';

const TrackerCard = ({
  title,
  hardwareList,
  rateplanTotal,
  rateplanTotalsList = [],
  additionalServicesTotal,
  addonsTotal,
  vehiclesTotal
}) => {
  const {
    iotOrderDetailsSection: {
      labelTotalNumberOf,
      labelTotalRateplans,
      labelTotalAddons,
      labelTotalAdditionalServices,
      labelTotalVehicles,
      labelGoAnywhere
    }
  } = useLocalizedStringsContext();

  return (
    <div>
      <TrackerTitle>{title}</TrackerTitle>
      <SummaryMain>
        <SummaryItemMain>
          <SummaryItemLabel>{labelTotalRateplans}</SummaryItemLabel>
          <SummaryItemCount>{rateplanTotal}</SummaryItemCount>
        </SummaryItemMain>
        {rateplanTotalsList.map(({ name, total }) => (
          <SummaryItemMain>
            <SummaryItemLabel>
              {labelTotalNumberOf} {name}
            </SummaryItemLabel>
            <SummaryItemCount>{total}</SummaryItemCount>
          </SummaryItemMain>
        ))}
        {Object.keys(hardwareList).map(hardwareName => (
          <SummaryItemMain>
            <SummaryItemLabel>
              {labelTotalNumberOf}
              {hardwareName === 'TB1-LTMTEL' ? labelGoAnywhere : hardwareName}
            </SummaryItemLabel>
            <SummaryItemCount>{hardwareList[hardwareName]}</SummaryItemCount>
          </SummaryItemMain>
        ))}
        {!!additionalServicesTotal && (
          <SummaryItemMain>
            <SummaryItemLabel>{labelTotalAdditionalServices}</SummaryItemLabel>
            <SummaryItemCount>{additionalServicesTotal}</SummaryItemCount>
          </SummaryItemMain>
        )}
        {/* {!!addonsTotal && (
          <SummaryItemMain>
            <SummaryItemLabel>{labelTotalAddons}</SummaryItemLabel>
            <SummaryItemCount>{addonsTotal}</SummaryItemCount>
          </SummaryItemMain>
        )} */}
        {!!vehiclesTotal && (
          <SummaryItemMain>
            <SummaryItemLabel>{labelTotalVehicles}</SummaryItemLabel>
            <SummaryItemCount>{vehiclesTotal}</SummaryItemCount>
          </SummaryItemMain>
        )}
      </SummaryMain>
    </div>
  );
};

TrackerCard.propTypes = {
  title: PropTypes.string.isRequired,
  hardwareList: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  rateplanTotalsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      total: PropTypes.number
    })
  ),
  rateplanTotal: PropTypes.number.isRequired,
  additionalServicesTotal: PropTypes.number.isRequired,
  addonsTotal: PropTypes.number.isRequired,
  vehiclesTotal: PropTypes.number.isRequired
};

export default TrackerCard;
